import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { anyDefined, expandDirectionalProperty, parseSides, spacingValue } from '../utils';

function space(_ref) {
  var padding = _ref.padding,
      paddingHorizontal = _ref.paddingHorizontal,
      paddingVertical = _ref.paddingVertical,
      paddingTop = _ref.paddingTop,
      paddingRight = _ref.paddingRight,
      paddingBottom = _ref.paddingBottom,
      paddingLeft = _ref.paddingLeft,
      margin = _ref.margin,
      marginHorizontal = _ref.marginHorizontal,
      marginVertical = _ref.marginVertical,
      marginTop = _ref.marginTop,
      marginRight = _ref.marginRight,
      marginBottom = _ref.marginBottom,
      marginLeft = _ref.marginLeft,
      gap = _ref.gap,
      columnGap = _ref.columnGap,
      rowGap = _ref.rowGap,
      styles = _objectWithoutPropertiesLoose(_ref, ["padding", "paddingHorizontal", "paddingVertical", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "margin", "marginHorizontal", "marginVertical", "marginTop", "marginRight", "marginBottom", "marginLeft", "gap", "columnGap", "rowGap"]);

  if (anyDefined(padding)) {
    if (typeof padding === 'string') {
      var paddingStyles = expandDirectionalProperty('padding', padding);
      styles.paddingTop = paddingStyles.paddingTop;
      styles.paddingRight = paddingStyles.paddingRight;
      styles.paddingBottom = paddingStyles.paddingBottom;
      styles.paddingLeft = paddingStyles.paddingLeft;
    } else {
      var paddingValue = parseSides(padding);
      styles.paddingTop = paddingValue;
      styles.paddingRight = paddingValue;
      styles.paddingBottom = paddingValue;
      styles.paddingLeft = paddingValue;
    }
  }

  if (anyDefined(paddingVertical, paddingTop)) {
    styles.paddingTop = parseSides(paddingVertical, paddingTop);
  }

  if (anyDefined(paddingHorizontal, paddingRight)) {
    styles.paddingRight = parseSides(paddingHorizontal, paddingRight);
  }

  if (anyDefined(paddingVertical, paddingBottom)) {
    styles.paddingBottom = parseSides(paddingVertical, paddingBottom);
  }

  if (anyDefined(paddingHorizontal, paddingLeft)) {
    styles.paddingLeft = parseSides(paddingHorizontal, paddingLeft);
  }

  if (anyDefined(margin)) {
    if (typeof margin === 'string') {
      var marginStyles = expandDirectionalProperty('margin', margin);
      styles.marginTop = marginStyles.marginTop;
      styles.marginRight = marginStyles.marginRight;
      styles.marginBottom = marginStyles.marginBottom;
      styles.marginLeft = marginStyles.marginLeft;
    } else {
      var marginValue = parseSides(margin);
      styles.marginTop = marginValue;
      styles.marginRight = marginValue;
      styles.marginBottom = marginValue;
      styles.marginLeft = marginValue;
    }
  }

  if (anyDefined(marginVertical, marginTop)) {
    styles.marginTop = parseSides(marginVertical, marginTop);
  }

  if (anyDefined(marginHorizontal, marginRight)) {
    styles.marginRight = parseSides(marginHorizontal, marginRight);
  }

  if (anyDefined(marginVertical, marginBottom)) {
    styles.marginBottom = parseSides(marginVertical, marginBottom);
  }

  if (anyDefined(marginHorizontal, marginLeft)) {
    styles.marginLeft = parseSides(marginHorizontal, marginLeft);
  }

  if (gap !== undefined) {
    styles.gap = spacingValue(gap);
  }

  if (columnGap !== undefined) {
    styles.columnGap = spacingValue(columnGap);
  }

  if (rowGap !== undefined) {
    styles.rowGap = spacingValue(rowGap);
  }

  return styles;
}

export default space;